export default {
  nav: {
    home: 'Home',
    manufacturers: 'Fabricantes',
    products: 'Produtos',
    about: 'Sobre nós',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Contato',
    getQuote: 'Solicitar orçamento',
  },
  langModal: {
    title: 'Somos globais',
    chooseLocation: 'Escolha a sua localização',
  },
  header: {
    email: "webenquiries{'@'}gmgautomation.net",
    phone: '+39 040 957 1062',
    language: 'Português',
    searchPlaceholder: 'Pesquise por número de peça ou fabricante',
    noResults: 'Nenhuma peça encontrada',
    enquiryLink: 'Enviar uma consulta',
    enquiryLinkSub: 'Não encontra a sua peça? Diga-nos',
  },
  quoteDrawer: {
    title: 'Envie uma consulta de preço',
    parts: 'Número de peça',
    addPart: 'Adicionar outro item',
  },
  home: {
    hero: {
      title: 'Pesquise por número de peça e encontre peças de automação, {highlight} e atuais',
      highlight: 'obsoletas',
      subtitle:
        'Descubra nossa ampla gama de produtos para todas as suas necessidades, incluindo controladores, CLPs, IHMs, motores, codificadores, drives de servo, inversores, sistemas CNC e muito mais',
      searchPlaceholder: 'Insira o número da peça...',
      search: 'Pesquisar',
    },
    manufacturers: {
      title: 'Fabricantes',
      subtitle:
        'Nosso extenso estoque compreende milhares de componentes de automação e controle de OEMs de primeira linha, tornando-o uma solução completa para suas necessidades. Se uma peça não estiver em estoque, tenha certeza de que nossa equipe multilíngue pesquisará em todo o mundo para adquirir o componente exato que você precisa pelo preço mais competitivo.',
      viewProducts: 'Ver produtos',
      viewAll: 'Ver todos os fabricantes',
    },
    whyUs: {
      title: 'Por que escolher a GMG Automation?',
      subtitle: 'Os valores que fazem de nós um parceiro de confiança em automação industrial',
      quality: {
        title: 'Serviço de qualidade',
        description: 'Atendimento ao cliente amigável e experiente para fornecer soluções rápidas e eficientes.',
      },
      shipping: {
        title: 'Entrega rápida',
        description: 'Entrega no mesmo dia para peças em estoque ou remessa expressa de nossa rede global.',
      },
      warranty: {
        title: '12 meses de garantia',
        description:
          'Oferecemos 12 meses de garantia para todas as peças, sejam elas novas, recondicionadas, reparadas ou em troca de serviço.',
      },
    },
    services: {
      title: 'Serviços',
      subtitle: 'Soluções completas para as suas necessidades de peças sobressalentes para automação',
      learnMore: 'Saber mais',
      supply: {
        title: 'Fornecer',
        description:
          'Temos o cuidado de entregar sua peça do nosso estoque ou do nosso fornecedor diretamente na sua porta.',
      },
      exchange: {
        title: 'Serviço de Troca',
        description:
          'Retomamos sua unidade defeituosa em troca de uma unidade testada e funcional com grande desconto.',
      },
      repair: {
        title: 'Reparar',
        description: 'Podemos reparar milhares de itens a preços fixos.',
      },
    },
  },
  manufacturers: {
    searchPlaceholder: 'Pesquisar fabricantes...',
    noResults: 'Nenhum fabricante encontrado',
    hero: {
      title: 'Fabricantes',
      subtitle: 'Conheça a nossa ampla gama de fabricantes e verifique a disponibilidade de milhares de produtos',
      badges: {
        warranty: { title: 'Garantia de 12 meses', subtitle: 'Em todas as peças fornecidas' },
        response: { title: 'Resposta rápida', subtitle: 'Dentro de 24 horas' },
        delivery: { title: 'Entrega global', subtitle: 'Envio para todo o mundo' },
      },
    },
    products: {
      hero: {
        subtitle: 'Não encontra o que procura? Ligue-nos ou envie-nos um pedido de informação',
      },
      searchPlaceholder: 'Pesquisar por número da peça...',
      showingEntries: 'A mostrar {from}–{to} de {total} peças',
      noResults: 'Nenhuma peça encontrada',
    },
  },
  about: {
    hero: {
      title: 'Nosso objetivo',
      subtitle:
        'Encontrar as peças de reposição que você precisa para minimizar o tempo de inatividade e/ou contrabalançar os longos prazos de entrega dos fabricantes',
    },
    values: {
      fast: {
        title: 'Rápido',
        desc: 'Somos conhecidos pela nossa resposta rápida, nos orgulhamos de atender prontamente às necessidades dos nossos clientes, garantindo um tempo mínimo para restaurar seus sistemas de automação ao máximo desempenho.',
      },
      friendly: {
        title: 'Amigável',
        desc: 'Experimente um serviço de atendimento ao cliente incomparável com nossa equipe amigável e dedicada, sempre pronta para ajudá-lo com um sorriso, tornando sua jornada conosco tranquila e satisfatória.',
      },
      experienced: {
        title: 'Eficiência',
        desc: 'A eficiência é o núcleo das nossas operações, respondendo às suas necessidades de automação de forma que você possa ficar tranquilo em todos os momentos.',
      },
      reliable: {
        title: 'Confiável',
        desc: 'A confiabilidade é um aspecto constante em todas as nossas operações. Você pode verificar isso desde o primeiro momento ao nos fazer uma consulta ou enviar um pedido até o último momento de receber suas peças de reposição.',
      },
    },
    story1: {
      title:
        'A nossa equipa conseguiu compreender as necessidades do setor e criar serviços fiáveis para as satisfazer a todas',
      text: 'A GMG Automation leva em consideração as preocupações de seus clientes que procuram soluções para falhas em suas máquinas ou para a necessidade de peças de reposição obsoletas. Por isso, desenvolvemos uma rede global de fornecedores para oferecer soluções econômicas e rápidas.',
    },
    story2: {
      title: 'Criar um serviço confiável, seguro e rápido',
      text: 'Com mais de 10 anos de experiência no setor de automação e uma equipe multilíngue à sua disposição, não deixaremos suas máquinas inativas!',
    },
  },
  blog: {
    hero: {
      title: 'Blog',
      subtitle: 'Fique por dentro das últimas notícias e análises da nossa equipe',
    },
    empty: 'Nenhum artigo encontrado.',
    back: 'Voltar ao blog',
    label: 'Artigo',
    related: 'Artigos relacionados',
  },
  faq: {
    hero: {
      title: 'FAQ',
      subtitle: 'Consulte as nossas perguntas frequentes',
    },
    search: 'Pesquisar perguntas frequentes',
    empty: 'Nenhuma pergunta frequente encontrada.',
  },
  contact: {
    hero: {
      title: 'Fale conosco',
      subtitle:
        'Na GMG Automation, somos mais do que simples revendedores de peças de automação: somos parceiros comprometidos com o seu sucesso. Com uma equipe dedicada e multilíngue à sua disposição, estamos prontos para ajudá-lo em qualquer dúvida que você tenha',
    },
    offices: {
      title: 'Nossos escritórios',
    },
    form: {
      title: 'Entre em contato',
      name: 'Nome',
      company: 'Nome da empresa',
      email: 'Endereço de e-mail',
      nameRequired: 'O nome é obrigatório.',
      companyRequired: 'O nome da empresa é obrigatório.',
      emailRequired: 'O e-mail é obrigatório.',
      phoneRequired: 'O telefone é obrigatório.',
      phone: 'Número de telefone',
      phonePlaceholder: 'Ex. +351 21 234 5678',
      message: 'Por favor, informe os detalhes da sua solicitação',
      send: 'Enviar',
      sending: 'Enviando...',
      successTitle: 'Mensagem enviada',
      successDetail: 'Entraremos em contato o mais breve possível.',
      errorTitle: 'Erro',
      errorDetail: 'Algo deu errado. Tente novamente.',
    },
    plantAddresses: {
      title: 'Endereço e dados bancários',
      regNumber: 'Número de registro da empresa',
      phone: 'Telefone',
      bankDetails: 'Dados bancários',
      beneficiary: 'Beneficiário',
    },
  },
  terms: {
    hero: {
      title: 'Termos e Condições',
    },
    empty: 'Nenhum termo e condição encontrado.',
  },
  privacy: {
    hero: {
      title: 'Política de Privacidade',
    },
    empty: 'Nenhuma política de privacidade encontrada.',
  },
  cookie: {
    hero: { title: 'Política de Cookies' },
    empty: 'Nenhuma política de cookies encontrada.',
    banner: {
      message:
        'Usamos cookies para melhorar sua experiência em nosso site. Ao continuar navegando, você concorda com o uso de cookies.',
      learnMore: 'Política de Cookies',
      necessaryOnly: 'Apenas necessários',
      acceptAll: 'Aceitar tudo',
    },
  },

  product: {
    manufacturer: 'Fabricantes',
    partNumberLabel: 'Número de peça',
    noDescription: 'Sem descrição disponível',
    inStock: 'Em stock',
    available: 'Disponível',
    qty: 'Quantidade',
    addToCart: 'Adicionar ao carrinho',
    addedToCart: 'Adicionado ao carrinho',
    enquiryTitle: 'Consulta Rápida',
    warrantyText: 'Todos os produtos incluem 12 meses de garantia.',
    fetchError: 'Não foi possível carregar o produto.',
    trust: {
      warranty: '12 meses de garantia em todos os produtos',
      shipping: 'Envio rápido para todo o mundo',
      support: 'Suporte profissional ao cliente',
    },
    features: {
      quality: 'Produto de qualidade',
      delivery: 'Entrega rápida',
      warranty: 'Garantia de 12 meses',
    },
    tabs: {
      description: 'Descrição',
      warranty: 'Garantia',
    },
  },

  enquiryForm: {
    companyName: 'Nome da empresa',
    yourName: 'Nome',
    email: 'Email',
    country: 'Selecione o pais',
    partNumber: 'Número de peça',
    quantity: 'Quantidade',
    send: 'Enviar',
    phoneInput: {
      placeholder: 'Telefone',
      searchPlaceholder: 'Pesquisa',
    },
    successTitle: 'Consulta enviada',
    successDetail: 'Entraremos em contacto consigo em breve.',
    errorTitle: 'Algo correu mal',
    errorDetail: 'Por favor, tente novamente mais tarde.',
  },

  searchEnquiry: {
    title: 'Resultados da pesquisa por',
    whatNext: {
      title: 'Depois de enviar a sua solicitação',
      step1Title: '1. E-mail de Confirmação',
      step1Text: 'Você receberá um e-mail confirmando que recebemos a sua solicitação.',
      step2Title: '2. Gestor de Conta Dedicado',
      step2Text:
        'Um membro da nossa equipa entrará em contacto consigo para confirmar as especificações e o estado das suas peças.',
      step3Title: '3. O seu orçamento',
      step3Text: 'Receberá um orçamento completo, adaptado às suas necessidades específicas.',
      legal: 'Todos os pedidos estão sujeitos à disponibilidade do produto.',
      legalLink: 'Consulte os nossos Termos e Condições.',
      askTeam: 'Fale com a nossa equipa',
      emailLabel: 'Email',
    },
  },

  cart: {
    title: 'Carrinho de solicitações',
    empty: 'O seu carrinho está vazio',
    emptySub: 'Adicione peças das páginas de produtos para começar',
    browse: 'Explorar peças',
    itemCount: '{count} peça | {count} peças',
    partNumber: 'Número de peça',
    availability: 'Disponibilidade',
    quantity: 'Quantidade',
    clearAll: 'Limpar tudo',
    clearTitle: 'Limpar carrinho',
    clearConfirm: 'Tem a certeza de que deseja remover todos os itens do carrinho?',
    clear: 'Limpar',
    cancel: 'Cancelar',
    enquirySubtitle: '{count} peça na sua consulta | {count} peças na sua consulta',
    addedTitle: 'Adicionado ao carrinho',
    addedDetail: '{partNumber} foi adicionado ao seu carrinho de consulta',
  },

  footer: {
    contact: {
      title: 'Outras formas de nos contatar',
      subtitle:
        'Entre em contato conosco por telefone ou preenchendo um formulário online, ficaremos felizes em ajudar!',
      formTitle: 'Enviar formulário online',
      formSubtitle: 'Partilhe os seus requisitos e responderemos em 24 horas.',
      enquiry: 'Enviar consulta',
      callTitle: 'Ligue-nos',
      callSubtitle: 'Fale diretamente com a nossa equipa multilingue.',
    },
    sections: {
      manufacturers: 'Fabricantes',
      quickLinks: 'Links rápidos',
      connect: 'Contacto',
    },
    actions: {
      whatsapp: 'WhatsApp',
    },
    legal: {
      rights: 'Todos os direitos reservados',
      privacy: 'Condições de utilização',
      terms: 'Termos',
    },
    recaptcha: 'Protegido pelo reCAPTCHA',
    recaptchaPrivacy: 'Política de Privacidade',
    recaptchaTerms: 'Termos de Utilização',
    disclaimer:
      'A GMG Automation não é distribuidora nem representante autorizada das marcas presentes neste site. As marcas registadas e os nomes mencionados neste site pertencem aos seus respetivos proprietários.',
  },

  common: {
    noResults: 'Sem resultados',
  },

  validation: {
    required: 'Este campo é obrigatório',
    emailInvalid: 'Por favor, introduza um endereço de e-mail válido',
    tooLong: 'Não deve exceder {max} caracteres',
    recaptchaError: 'A verificação do reCAPTCHA falhou. Por favor, tente novamente.',
  },

  seo: {
    home: {
      title: 'GMG Automation — Peças de Reposição para Automação Industrial',
      description: 'Encontre peças obsoletas e atuais para automação industrial. Pesquise por número de peça e solicite um orçamento em 24 horas. Controladores, PLCs, HMIs, servoaccionamentos e mais.',
    },
    manufacturers: {
      title: 'Fabricantes — GMG Automation',
      description: 'Explore peças de automação por fabricante. Siemens, ABB, Schneider Electric, Fanuc e centenas de outros. Envio rápido para todo o mundo com garantia de 12 meses.',
    },
    about: {
      title: 'Sobre Nós — GMG Automation',
      description: 'Mais de 10 anos de experiência em peças de reposição para automação industrial. Equipa multilingue, rede global de fornecedores, resposta rápida e garantia de 12 meses em todas as peças.',
    },
    blog: {
      title: 'Blog — GMG Automation',
      description: 'Fique a par das últimas notícias, análises do setor e artigos técnicos da equipa GMG Automation.',
    },
    faq: {
      title: 'FAQ — GMG Automation',
      description: 'Respostas às perguntas mais frequentes sobre encomendas, envios, pagamentos e garantia na GMG Automation.',
    },
    contact: {
      title: 'Contacto — GMG Automation',
      description: 'Entre em contacto com a equipa GMG Automation. Ligue-nos, envie um formulário ou escreva-nos diretamente. Respondemos em 24 horas.',
    },
    terms: {
      title: 'Termos e Condições — GMG Automation',
      description: 'Leia os termos e condições que regem a utilização dos serviços GMG Automation e a compra de peças industriais.',
    },
    privacy: {
      title: 'Política de Privacidade — GMG Automation',
      description: 'Saiba como a GMG Automation recolhe, utiliza e protege os seus dados pessoais de acordo com as regulamentações de privacidade aplicáveis.',
    },
    cookie: {
      title: 'Política de Cookies — GMG Automation',
      description: 'Saiba mais sobre os cookies utilizados no site da GMG Automation e como gerir as suas preferências.',
    },
    product: {
      description: 'Compre {partNumber} de {manufacturer}. Solicite um orçamento para entrega rápida em todo o mundo. Garantia de 12 meses incluída.',
    },
    manufacturerProducts: {
      description: 'Explore peças de reposição e componentes de automação {manufacturer}. Pesquise por número de peça e solicite um orçamento com envio rápido.',
    },
  },
}
